module.exports = __webpack_public_path__ + "img/what-people-say.5c1c8d73.png";